import { JSX } from "react";

export const BookmarkStar = (): JSX.Element => {
    return (
        <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.29375 8.5L6 7.46875L7.70625 8.5L7.25625 6.55L8.75625 5.25625L6.7875 5.0875L6 3.25L5.2125 5.0875L3.24375 5.25625L4.74375 6.55L4.29375 8.5ZM0.75 13.75V1.75C0.75 1.3375 0.896875 0.984375 1.19063 0.690625C1.48438 0.396875 1.8375 0.25 2.25 0.25H9.75C10.1625 0.25 10.5156 0.396875 10.8094 0.690625C11.1031 0.984375 11.25 1.3375 11.25 1.75V13.75L6 11.5L0.75 13.75ZM2.25 11.4625L6 9.85L9.75 11.4625V1.75H2.25V11.4625Z"
                fill="#1D2D58"
            />
        </svg>
    );
};
